export const charts: ChartsSetup = {
    axesMultiplier: 1.2,
    barGap: 5,
    dayLabels: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    handleDragIndicatorWidth: 17,
    handleHeight: 20,
    height: 350,
    margin: {
        bottom: 50,
        left: 80,
        right: 100,
        top: 30,
    },
    variants: {
        dailyPeople: {
            title: 'People Walking By Per Day',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: 'People' },
            },
        },
        dailyRevenue: {
            title: 'Revenue Per Day',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: '$', tooltipLabel: 'Revenue', tooltipPrefix: '$' },
            },
        },
        hungryPeople: {
            title: '% Of People Walking by Who Are Hungry',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: '%', tooltipLabel: 'Hungry', tooltipSuffix: '%' },
            },
        },
        lookingPeople: {
            title: '% Of Hungry People Who Look At The Menu',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: '%', tooltipLabel: 'Looks', tooltipSuffix: '%' },
            },
        },
        orderingPeople: {
            title: '% Of People Looking At The Menu Who Order',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: '%', tooltipLabel: 'Orders', tooltipSuffix: '%' },
            },
        },
        orderRevenue: {
            title: '$ Per Order',
            axes: {
                x: { label: 'Days', tooltipLabel: 'Day' },
                y: { label: '$', tooltipLabel: 'Revenue', tooltipPrefix: '$' },
            },
        },
        retention: {
            title: '% Of Returning Customers',
            axes: {
                x: { label: 'Weeks', tooltipLabel: 'Week' },
                y: { label: '%', max: 100, tooltipLabel: 'Returns', tooltipSuffix: '%' },
            },
        },
        simulation: {
            title: 'Simulation - 6 Month Revenue',
            axes: {
                x: { label: 'Weeks' },
                y: { label: '$' },
            },
        },
        weeklyRevenue: {
            title: 'Revenue Per Week',
            axes: {
                x: { label: 'Weeks', tooltipLabel: 'Week' },
                y: { label: '$', tooltipLabel: 'Revenue', tooltipPrefix: '$' },
            },
        },
    },
};